import { useEffect, useRef, useState } from 'react'

/**
 * Returns a scrollY value that updates on rAF, throttled to the frame rate.
 * Components use this to compute their own offset via `scrollY * speed`.
 */
export function useScrollY() {
  const [scrollY, setScrollY] = useState(0)
  const rafRef = useRef<number>(0)

  useEffect(() => {
    const onScroll = () => {
      cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(() => setScrollY(window.scrollY))
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      cancelAnimationFrame(rafRef.current)
    }
  }, [])

  return scrollY
}
